import { useParams } from 'react-router-dom';

import type { PageHeaderBreadcrumb } from '@verantos-dev/shared-components';

import { useProjectArtifacts } from './useProjectArtifacts';
import { useProjectRootBreadcrumbs } from './useProjectRootBreadcrumbs';

export interface UseDatasetBreadcrumbsResult {
  breadcrumbs: PageHeaderBreadcrumb[];
  /** Resolved dataset name (undefined while loading / not found). */
  datasetName: string | undefined;
  isLoading: boolean;
}

/**
 * Per-page breadcrumbs for the project analytical-dataset detail/placeholder
 * page (OR-6123 F8). `Projects / <project> / <dataset>` — the dataset name
 * comes from the project artifact manifest (the same source the old
 * monolithic `useProjectBreadcrumbs` used; feature-project-page can't import
 * feature-analytical-datasets without a dependency cycle).
 *
 * TODO: cleanup with research_assistant_gen_3 ff
 */
export const useDatasetBreadcrumbs = (): UseDatasetBreadcrumbsResult => {
  const { projectId = '', datasetId = '' } = useParams<{
    projectId: string;
    datasetId: string;
  }>();
  const { rootCrumbs } = useProjectRootBreadcrumbs();

  const { artifacts, isLoading } = useProjectArtifacts(datasetId ? projectId : '');
  const datasetName = datasetId
    ? artifacts.find((a) => a.kind === 'analytical_dataset' && a.id === datasetId)?.name
    : undefined;

  return {
    breadcrumbs: [
      ...rootCrumbs,
      {
        label: datasetName ?? '',
        isLoading: isLoading && !datasetName,
      },
    ],
    datasetName,
    isLoading,
  };
};
